import { render, staticRenderFns } from "./DialogFooter.vue?vue&type=template&id=676868e7&scoped=true"
import script from "./DialogFooter.vue?vue&type=script&lang=js"
export * from "./DialogFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676868e7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('676868e7')) {
      api.createRecord('676868e7', component.options)
    } else {
      api.reload('676868e7', component.options)
    }
    module.hot.accept("./DialogFooter.vue?vue&type=template&id=676868e7&scoped=true", function () {
      api.rerender('676868e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/datasource/DialogFooter.vue"
export default component.exports